import React from 'react';
import { Box, Paper, Grid, Typography } from '@mui/material';

const summaryItems = [
  { key: 'total', label: '전체', color: 'primary' },
  { key: 'notStarted', label: '미진행', color: 'text.secondary' },
  { key: 'inProgress', label: '진행중', color: 'info.main' },
  { key: 'awaitingShipment', label: '출고대기', color: 'warning.main' },
  { key: 'shipped', label: '출고완료', color: 'success.main' },
  // 완료(제조 상태 '완료')는 출고완료(shipmentStatus='Y')와는 다른 기준이라 별도 카드로 둔다.
  { key: 'completed', label: '완료', color: 'secondary.main' },
];

const ManufacturingSummary = ({ totals }) => {
  return (
    // 휴대폰에서는 숨긴다. 바로 위 상태 칩(전체(10)·미시작(1)…)이 같은 건수를 보여 주는데, 이 상자는
    // 한 줄에 하나씩 쌓여 첫 화면 절반을 차지했다(2026-10-08 모바일 점검).
    <Box sx={{ p: 2, display: { xs: 'none', sm: 'block' } }}>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Grid container spacing={2}>
          {summaryItems.map((item) => (
            <Grid item xs={12} sm={6} md={2} key={item.key}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {item.label}
                </Typography>
                <Typography variant="h5" color={item.color} fontWeight="bold">
                  {totals[item.key]}건
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
};

export default ManufacturingSummary;
